import React from 'react'
import PropTypes from 'prop-types'

// Components
import ScrollSection from '../ScrollSection'
import Container from '../Container'
import Grid from '../Grid'
import GridItem from '../GridItem'
import RichText from '../RichText'
import Spacer from '../Spacer'
import AmenitiesItem from '../AmenitiesItem'

// Styles
import { AmenitiesMain, AmenitiesList } from './index.style'

const AmenitiesTips = ({ id, heading, listItems, linkId }) => (
  <ScrollSection id={linkId}>
    <AmenitiesMain>
      <Spacer size={[60, 120]} />

      <Container>
        <Grid>
          <GridItem
            tabletP={8}
            tabletPStart={2}
            tabletL={4}
            tabletLStart={2}
            deskM={3}
            deskMStart={2}
          >
            <RichText
              id={`${id}-heading`}
              content={heading}
              delayEm={true}
              forceHeading
            />
          </GridItem>

          <GridItem
            tabletP={10}
            tabletPStart={2}
            tabletL={6}
            tabletLStart={6}
            deskM={5}
            deskMStart={6}
          >
            <AmenitiesList>
              {listItems?.map((item, itemIndex) => {
                return (
                  <AmenitiesItem
                    key={itemIndex}
                    id={`${id}-amenity-${itemIndex}`}
                    bottomBorder={itemIndex !== listItems.length - 1}
                    align="left"
                    iconSize="small"
                    {...item}
                  />
                )
              })}
            </AmenitiesList>
          </GridItem>
        </Grid>
      </Container>

      <Spacer size={[60, 120]} />
    </AmenitiesMain>
  </ScrollSection>
)

AmenitiesTips.propTypes = {
  id: PropTypes.string.isRequired,
  heading: PropTypes.object,
  text: PropTypes.object,
  disclaimer: PropTypes.string,
  listItems: PropTypes.array,
  linkId: PropTypes.string,
}

export default AmenitiesTips
